<template>
    <div class="flex" style="cursor: default;">
        <div class="black-background flex flex-column">
            <p>Apelează la un consultant.</p>
            <p><strong>office@gwconsulting.ro</strong></p>
            <img src="@/assets/images/gw-alb.png" alt="" style="max-width: 125px; margin-top: 5px;">
        </div>
        <b-overlay :show="offerLoading" class="yellow-background" :class="offerSent ? 'green-background' : ''">
            <div v-if="!offerSent">
                <p><strong>Ai nevoie de un consultant care să îți scrie și depună proiectul?</strong></p>
                <p>Smis® & Goodwill Consulting îți sunt alături. Beneficiezi de o reducere egală cu costul achitat
                    pentru licența <strong>POC</strong>Sketch, exclusiv la Goodwill Consulting</p>
                <div class="space-between flex-end">
                    <div class="space-between align-center max-width mt-2">
                        <p>Reducerea ta</p>
                        <div class="price-display">
                            <p>-{{ discount }} lei</p>
                        </div>
                    </div>
                    <div class="black-button" style="cursor: pointer;" @click.stop="sendGwOffer()">Vreau să fiu contactat/ă</div>
                </div>
                <p v-if="offerSent" style="text-align: center; margin-top: 5px;">Cererea a fost trimisă cu succes!</p>
            </div>
            <div v-else>
                <p style="text-align: center; margin-top: 5px;">Cererea a fost trimisă cu succes către <strong>Goodwill</strong>!</p>
                <p style="text-align: center; margin-top: 5px;">Vei beneficia de o reducere de <strong>-{{ discount }} lei</strong></p>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import { BOverlay } from "bootstrap-vue";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import _ from "lodash";
    export default {
        components: {
            BOverlay
        },
        props: {
            consultantVisible: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                offerSent: false,
                offerLoading: false,
                discount: 0,
                help_moneyM1: 0,
                help_moneyM2: 0,
                help_moneyHoreca: 0,
                help_moneyIMM: 0,
                form: {

                }
            }
        },
        computed: {
            companyChanged() {
                return this.$store.getters['companyChanged/companyChanged']
            },
            stateAids() {
                return this.$store.getters['stateAids/getStateAids']
            }
        },
        watch: {
            companyChanged: {
                handler: function() {
                    if(this.companyChanged) {
                        this.getStatus()
                        this.$store.dispatch('companyChanged/setChanged', false);
                    }
                }
            }
        },
        mounted() {
            this.getDiscount()
            this.getStatus()
        },
        methods: {
            getDiscount() {
                axios.get(api.API_ENDPOINTS.goodwillDiscount)
                    .then(response => {
                        this.discount = response.data.discount
                    })
            },
            getStatus() {
                if(JSON.parse(localStorage.getItem('currentM3Company')) && JSON.parse(localStorage.getItem('currentM3Company')).business_id) {
                    axios.get(api.API_ENDPOINTS.goodwillStatus + JSON.parse(localStorage.getItem('user')).id + '/' + JSON.parse(localStorage.getItem('currentM3Company')).business_id )
                        .then(response => {
                            this.offerSent = !response.data.available
                        })
                }
            },
            calculateCoFinancing(data, maxBudget) {
                if (data && data.cofinancing !== null) {
                    return ((data.cofinancing / 100) * Number(maxBudget)).toFixed(0)
                }
            },
            caMinim(data) {
                let caMinim2019 = _.filter(data.bilant_scurt, v => v.an === 2019);
                let cursEuro = 4.946
                if(caMinim2019[0]){
                    return (caMinim2019[0].cifra_de_afaceri_neta / cursEuro) >= 10000;
                }
            },
            checkEligible(bilant2019, response3, response5, response4) {
                let eligible = response4.isEligible
                if(
                    !(bilant2019 && bilant2019.profit_net > 0)
                    || !(response3 && response3.vechime > 2)
                    || !(response5.CA_2020 && Number(response5.CA_2020) > 0)
                    || (response5.CA_2020 > 250000000 && response5.nr_angajati_2020 > 250)
                    || !this.caMinim(response3)
                ) {
                    eligible = false
                }
                return eligible
            },
            sendGwOffer() {
                if(!this.offerSent && !this.offerLoading){
                    this.offerLoading = true
                    axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id)
                        .then( response => {
                            axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v3')
                                .then( response3 => {
                                    axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v2')
                                        .then( response4 => {
                                            axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v1')
                                                .then( response5 => {
                                                    let bilant2019 = _.filter(response3.data.bilant_scurt, v => v.an === 2019)[0]
                                                    let bilant2020 = _.filter(response3.data.bilant_scurt, v => v.an === 2020)[0]
                                                    this.form.name = this.$store.getters['auth/user'].name
                                                    this.form.email = this.$store.getters['auth/user'].email
                                                    this.form.phone = this.$store.getters['auth/user'].phone
                                                    this.form.business_id = response.data.business_id
                                                    this.form.company = response.data.name
                                                    this.form.score = response4.data.evaluation.score
                                                    this.form.caen = response.data.main_caen
                                                    this.form.secondary_caen = _.map(response3.data.coduriCaenSecundare, 'cod_caen_secundar').join(', ')
                                                    this.form.ca2019 = bilant2019.cifra_de_afaceri_neta
                                                    this.form.ca2020 = bilant2020.cifra_de_afaceri_neta
                                                    this.form.finantareMaxim = response.data.max_budget
                                                    this.form.cofinantare = this.calculateCoFinancing(response4.data, response.data.max_budget)
                                                    this.form.eligible = this.checkEligible(bilant2019, response3.data, response5.data, response4.data)

                                                    let ajutorM1;
                                                    let ajutorM2;
                                                    let ajutorHoreca;
                                                    ajutorM1 = this.stateAids.m1
                                                    ajutorM2 = this.stateAids.m2
                                                    ajutorHoreca = this.stateAids.horeca

                                                    if (ajutorM1) {
                                                        if (ajutorM1['Status contract'] !== 'Respins') {
                                                            this.help_moneyM1 = '9679'
                                                        } else {
                                                            this.help_moneyM1 = 0
                                                        }
                                                    }

                                                    if (ajutorM2) {
                                                        if (ajutorM2['Status contract'] !== 'Contract respins' && ajutorM2['Status contract'] !== 'Respins in lista de asteptare' && ajutorM2['Status contract'] !== 'Respins In lista de asteptare') {
                                                            this.help_moneyM2 = ajutorM2['Suma solicitata']
                                                        } else {
                                                            this.help_moneyM2 = 0
                                                        }
                                                    }
                                                    if (ajutorHoreca) {
                                                        if (ajutorHoreca.Status === 'Aprobată') {
                                                            this.help_moneyHoreca = ajutorHoreca['Suma solicitata']
                                                        } else {
                                                            this.help_moneyHoreca = 0
                                                        }
                                                    }
                                                    if (response3.data.imminvest && response3.data.imminvest.length > 0) {
                                                        this.help_moneyIMM = response3.data.imminvest[0] ? response3.data.imminvest[0].stare_solicitare : 0
                                                    }

                                                    this.form.m1 = this.help_moneyM1
                                                    this.form.m2 = this.help_moneyM2
                                                    this.form.horeca = this.help_moneyHoreca
                                                    this.form.imm = this.help_moneyIMM
                                                    this.form.statusTva = response.data.vat_status
                                                    this.form.angajati2020 = bilant2020.numar_mediu_angajati ? bilant2020.numar_mediu_angajati : 0
                                                    this.form.angajati2019 = bilant2019.numar_mediu_angajati ? bilant2019.numar_mediu_angajati : 0
                                                    this.form.capital2020 = bilant2020.capital_total
                                                    this.form.capital2019 = bilant2019.capital_total
                                                    this.form.county = response5.data.adresaRecom.judet
                                                    this.form.user_id = JSON.parse(localStorage.getItem('user')).id
                                                    axios.post(api.API_ENDPOINTS.goodwillMail, this.form)
                                                        .then(() => {
                                                            this.offerSent = true
                                                            this.offerLoading = false
                                                        })
                                                })
                                        })
                                })
                        })
                }
            }
        }
    }
</script>

<style scoped>
.green-background{
    background: #49cda8 !important;
}
.w-100{
    width: 100%;
    max-width: 1030px;
}
.flex{
    display: flex;
}
.flex-column{
    flex-direction: column;
}
.space-between{
    justify-content: space-between;
}
.align-center{
    align-items: center;
}
.flex-end{
    display: flex;
    align-items: flex-end;
}
.black-background{
    z-index: 1;
    padding: 20px;
    width: 35%;
    max-width: 290px;
    background: #191919;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}
.yellow-background{
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 0;
    margin-left: -2px;
    padding: 20px 20px 20px 22px;
    background: #ffba00;
    width: 65%;
    max-width: 740px;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
.black-background p, .yellow-background p{
    font-size: 14px;
    color: #fff;
}
.price-display{
    margin-left: 10px;
    padding: 1px 10px;
    border: 1px solid #fff;
}
.price-display p{
    font-size: 25px;
    font-weight: 600;
    line-height: 25px;
}
.black-button{
    background: #191919;
    padding: 2px 10px;
    font-size: 13px;
    color: #ffffff;
    font-weight: 700;
}
</style>
